import { render, staticRenderFns } from "./ttshop_evaluate.vue?vue&type=template&id=2f189c12&scoped=true"
import script from "./ttshop_evaluate.vue?vue&type=script&lang=js"
export * from "./ttshop_evaluate.vue?vue&type=script&lang=js"
import style0 from "./ttshop_evaluate.vue?vue&type=style&index=0&id=2f189c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f189c12",
  null
  
)

export default component.exports